import { createSelector } from "reselect";
import accessTokenSelector from "selectors/accessToken";
import loadTokenStatusSelector from "selectors/loadTokenStatus";

const authenticationStatusSelector = createSelector(
    accessTokenSelector,
    loadTokenStatusSelector,
    (
        accessToken,
        loadTokenStatus
    ): "authenticated" | "unauthenticated" | "loading" => {
        if (accessToken) {
            return "authenticated";
        }
        if (loadTokenStatus === "loading") {
            return "loading";
        } else {
            return "unauthenticated";
        }
    }
);

export default authenticationStatusSelector;
